import { Injectable } from "@angular/core";
import { Dataservice } from "./dataservice";
import { BaseResponse } from "../models/baseresponse";

@Injectable({
    providedIn: "root",
})
export class UserApiService {
    constructor(
        private dataService: Dataservice,
    ) { }

    adminLogin(data: any): Promise<any>{
        return new Promise<any>((resolve, reject) => {
            this.dataService.postRequest("api/v1/admin/", data).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }
    setUser(data: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.dataService.postRequest("api/v1/users", data).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }
    editUser(data: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.dataService.putRequest("api/v1/users", data).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }
    getAllUsers() {
        return new Promise<any>((resolve, reject) => {
            this.dataService.getRequest("api/v1/users/all").then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }
    deleteUser(id: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const body = {
                user_id: id,
            }
            this.dataService.deleteRequest("api/v1/users", body).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }
    getUserById(data: any){
        return new Promise<any>((resolve, reject) => {
            this.dataService.getRequest("api/v1/users/" , data).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }

    sendMediaLink(email: any){
        return new Promise<any>((resolve, reject) => {
            const body = {
                email: email,
            }
            this.dataService.postRequest("api/v1/users/verify", body).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }
    userByFilter(data: any){
        return new Promise<any>((resolve, reject) => {
            this.dataService.getRequest("api/v1/users/date" , data).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }
    submitRecording(data: any): Promise<any>{
        return new Promise<any>((resolve, reject) => {
            this.dataService.postRequest("api/v1/userMedia", data).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }

    changeMediaStatus(data: any): Promise<any>{
        return new Promise<any>((resolve, reject) => {
            this.dataService.putRequest("api/v1/users/media/verifylink/", data).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        }); 
    }
}
